import React from "react";
import logoNavarra from "../../assets/img/logo-gob-navarra-agenda-2030.png";
import icoNext from "../../assets/img/ico-seguent.svg";
import icoPrev from "../../assets/img/ico-anterior.svg";
import logoInm from "../../assets/img/logo-inm.png";

const ExpoFooter = ({next, prev}) => {
  return (
    <footer className="has-background-primary has-text-white">
      <div className="py-5 px-6 is-flex gap-5">
        <nav className="slides-nav is-flex gap-5 is-hidden-touch">
          <button onClick={prev} type="button" className="is-flex p-1">
            <img src={icoPrev} alt="Anterior" width="30" height="30"/>
          </button>
          <button onClick={next} type="button" className="is-flex p-1">
            <img src={icoNext} alt="Siguiente" width="31" height="30"/>
          </button>
        </nav>

        <div className="logos is-flex is-align-items-center gap-5">
          <a href="https://www.navarra.es/">
            <img
              loading="lazy"
              src={logoNavarra}
              alt="Gobierno de Navarra. Nafarroako Gobernua. Agenda 2030"
              width="187"
              height="41"
              className="is-block"
            />
          </a>
          <a href="https://pazyconvivencia.navarra.es/es/inm">
            <img
              loading="lazy"
              src={logoInm}
              alt="Instituto Navarro de la Memoria. Nafarroako Memoriaren Institutua"
              width="138"
              height="32"
              className="is-block"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default ExpoFooter;
